<template>
	<div>
		<v-card elevation="0" :style="'background-color:' + $theme.lightBlue">
			<v-card-title style="font-size: large">
				<v-icon size="20" color="black" style="margin-right: 10px">{{ 'mdi-menu' }}</v-icon>
				{{ '시술 목록 관리' }}
			</v-card-title>
			<v-row>
				<v-col>
					<!-- 대메뉴 테이블 -->
					<v-card elevation="2" class="mb-4">
						<v-card-title>
							대메뉴
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="addMenu(1)"> +추가</v-btn>
						</v-card-title>
						<v-data-table :headers="headers" :items="items.level1" item-value="code" :items-per-page="-1" hide-default-footer height="500px" fixed-header>
							<template v-slot:body>
								<draggable v-model="items.level1" tag="tbody" :handle="'.drag-handle'" @end="updateSortOrder(1)">
									<tr v-for="item in items.level1" :key="item.code" @click="editMenu(item, 1)">
										<td>
											<v-icon small class="drag-handle" @click.stop>mdi-menu</v-icon>
										</td>
										<td>{{ item.code }}</td>
										<td>{{ item.title }}</td>
										<td>{{ $utils.addComma(item.offerMinPrice + '') }}</td>
										<td>{{ item.useYn ? '사용' : '미사용' }}</td>
									</tr>
								</draggable>
							</template>
						</v-data-table>
					</v-card>
				</v-col>

				<!-- 중메뉴 테이블 -->
				<v-col>
					<v-card elevation="2" class="mb-4">
						<v-card-title>
							중메뉴
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="addMenu(2)">+추가</v-btn>
						</v-card-title>
						<v-data-table :headers="headers" :items="items.level2" item-value="code" :items-per-page="-1" hide-default-footer height="500px" fixed-header>
							<template v-slot:body>
								<draggable v-model="items.level2" tag="tbody" :handle="'.drag-handle'" @end="updateSortOrder(2)">
									<tr v-for="item in items.level2" :key="item.code" @click="editMenu(item, 2)">
										<td>
											<v-icon small class="drag-handle" @click.stop>mdi-menu</v-icon>
										</td>
										<td>{{ item.code }}</td>
										<td>{{ item.title }}</td>
										<td>{{ $utils.addComma(item.offerMinPrice + '') }}</td>
										<td>{{ item.useYn ? '사용' : '미사용' }}</td>
									</tr>
								</draggable>
							</template>
						</v-data-table>
					</v-card>
				</v-col>

				<!-- 소메뉴 테이블 -->
				<v-col>
					<v-card elevation="2">
						<v-card-title>
							소메뉴
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="addMenu(3)">+추가</v-btn>
						</v-card-title>
						<v-data-table :headers="headers" :items="items.level3" item-value="code" :items-per-page="-1" hide-default-footer height="500px" fixed-header>
							<template v-slot:body>
								<draggable v-model="items.level3" tag="tbody" :handle="'.drag-handle'" @end="updateSortOrder(3)">
									<tr v-for="item in items.level3" :key="item.code" @click="editMenu(item, 3)">
										<td>
											<v-icon small class="drag-handle" @click.stop>mdi-menu</v-icon>
										</td>
										<td>{{ item.code }}</td>
										<td>{{ item.title }}</td>
										<td>{{ $utils.addComma(item.offerMinPrice + '') }}</td>
										<td>{{ item.useYn ? '사용' : '미사용' }}</td>
									</tr>
								</draggable>
							</template>
						</v-data-table>
					</v-card>
				</v-col>
			</v-row>

			<MenuEditDialog
				:show="editDialog"
				:item="selectedItem"
				:title="dialogTitle"
				okButtonText="저장"
				cancelButtonText="닫기"
				deleteButtonText="삭제"
				@onOk="modifyItem"
				@onCancel="resetItem"
				@onDelete="deleteItemConfirm"
			>
			</MenuEditDialog>

			<MessageDialog
				:show="deleteMessageDialog"
				message="삭제하시겠습니까?"
				:okButton="true"
				cancelButtonText="취소"
				:deleteButton="true"
				deleteButtonText="삭제"
				@onOk="deleteItem"
				@onCancel="deleteMessageDialog = false"
			/>

			<!-- 처리중입니다 다이얼로그 -->
			<MessageDialog :show="workingStateDialog" message="처리중입니다. 잠시만 기다려주세요." :okButton="false" :cancelButton="false" />
		</v-card>
	</div>
</template>

<script>
	import draggable from 'vuedraggable';

	export default {
		name: 'MenuList',
		components: {
			draggable,
		},
		props: {
			items: {
				default: () => [],
			},
		},
		data: () => ({
			workingStateDialog: false,
			editDialog: false,
			deleteMessageDialog: false,
			dialogTitle: '',
			selectedMenuLevel: '',
			selectedItem: {},
			originalItem: {},
			isModify: false,
		}),
		methods: {
			addMenu(level) {
				// 메뉴 추가 버튼 클릭 시 팝업 열기
				this.selectedItem = this.$models.TreatmentModel.create();
				this.selectedMenuLevel = level;
				this.dialogTitle = `${level === 1 ? '대' : level === 2 ? '중' : '소'}메뉴 추가`;
				this.editDialog = true;
				this.isModify = false;
			},
			editMenu(item, level) {
				// 메뉴 수정 버튼 클릭 시
				this.originalItem = item;
				this.selectedItem = { ...item };
				this.dialogTitle = `${level === 1 ? '대' : level === 2 ? '중' : '소'}메뉴 수정`;
				this.editDialog = true;
				this.isModify = true;
			},
			async resetItem() {
				this.selectedItem = this.originalItem;
				this.editDialog = false;
			},
			async modifyItem() {
				this.$emit('modifyItem', {
					items: this.items[`level${this.selectedMenuLevel}`],
					item: this.selectedItem,
					isModify: this.isModify,
					level: this.selectedMenuLevel,
				});
				this.editDialog = false;
			},
			async updateSortOrder(level) {
				const list = this.items[`level${level}`];

				console.log(level, list);

				for (let i = 0; i < list.length; i++) {
					console.log(level, list[i].code, list[i].title);
					list[i].sort = i + 1;
					await this.$database.modifyTreatment(list[i]);
				}
			},
			async deleteItemConfirm() {
				this.deleteMessageDialog = true;
			},
			async deleteItem() {
				this.$emit('deleteItem', this.selectedItem);
				this.deleteMessageDialog = false;
			},
		},
		computed: {
			headers() {
				return [
					{ text: '정렬', value: 'sort', align: 'center', sortable: false },
					{ text: '메뉴코드', value: 'code', align: 'center', sortable: false },
					{ text: '메뉴명', value: 'title', align: 'center', sortable: false },
					{ text: '제안 최소 금액 (원)', value: 'offerMinPrice', align: 'center', sortable: false },
					{ text: '사용 여부', value: 'useYn', align: 'center', sortable: false },
				];
			},
		},
	};
</script>

<style scoped>
	.mb-4 {
		margin-bottom: 1.5rem;
	}
</style>
